var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9883 36.75H42.2383V7.5C42.2383 6.90326 42.0012 6.33097 41.5793 5.90901C41.1573 5.48705 40.585 5.25 39.9883 5.25H29.4883C28.8915 5.25 28.3192 5.48705 27.8973 5.90901C27.4753 6.33097 27.2383 6.90326 27.2383 7.5V14.25H18.9883C18.3915 14.25 17.8192 14.4871 17.3973 14.909C16.9753 15.331 16.7383 15.9033 16.7383 16.5V23.25H9.98828C9.39154 23.25 8.81925 23.4871 8.39729 23.909C7.97533 24.331 7.73828 24.9033 7.73828 25.5V36.75H6.98828C6.39154 36.75 5.81925 36.9871 5.39729 37.409C4.97533 37.831 4.73828 38.4033 4.73828 39C4.73828 39.5967 4.97533 40.169 5.39729 40.591C5.81925 41.0129 6.39154 41.25 6.98828 41.25H42.9883C43.585 41.25 44.1573 41.0129 44.5793 40.591C45.0012 40.169 45.2383 39.5967 45.2383 39C45.2383 38.4033 45.0012 37.831 44.5793 37.409C44.1573 36.9871 43.585 36.75 42.9883 36.75ZM31.7383 9.75H37.7383V36.75H31.7383V9.75ZM21.2383 18.75H27.2383V36.75H21.2383V18.75ZM12.2383 27.75H16.7383V36.75H12.2383V27.75Z",
    fill: "url(#paint0_linear_1567_21886)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1567_21886",
    x1: 24.9883,
    y1: 5.25,
    x2: 24.9883,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/ChartBar.37e33240c940d7ecfe89f5ade22cd0bf.svg";
export { ForwardRef as ReactComponent };